import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import type { WebinarEntry } from 'api/microlearning/types'

import 'dayjs/locale/id'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('id')

export const filterByModuleTopicId = (
  webinarEntries: WebinarEntry[],
  currentTopicId: number
): WebinarEntry[] => {
  return webinarEntries.filter((webinarEntry) => {
    const modulesTopicIds = webinarEntry.module.map((module) => module.topikId)

    if (modulesTopicIds.includes(currentTopicId)) return webinarEntry
  })
}

const WIB_TIME = dayjs().tz('Asia/Jakarta')
const MINUTES_CUTOFF_FILTER = 30

export const filterByDate = (
  webinarEntries: WebinarEntry[]
): WebinarEntry[] => {
  return webinarEntries.filter((webinarEntry) => {
    return WIB_TIME.isBefore(
      dayjs(webinarEntry.endDate).add(MINUTES_CUTOFF_FILTER, 'minute')
    )
  })
}

export const sortByDate = (webinarEntries: WebinarEntry[]): WebinarEntry[] => {
  return webinarEntries.sort((a, b) => {
    const aStartDate = dayjs(a.startDate)
    const bStartDate = dayjs(b.startDate)

    if (aStartDate.isBefore(bStartDate)) return -1
    if (aStartDate.isAfter(bStartDate)) return 1
    return 0
  })
}
